import {
  Dialog,
  DialogTitle,
  DialogContent,
  makeStyles,
  DialogSurface,
  DialogBody,
  DialogTrigger,
  Button,
  Tooltip,
} from "@fluentui/react-components";
import { Body1, Subtitle1 } from "@fluentui/react-components";
import {
  Document20Regular,
  Dismiss24Regular,
  ArrowDownload20Filled,
} from "@fluentui/react-icons";
import moment from "moment";
import { AppDispatch } from "../../../../redux/store";
import { useDispatch } from "react-redux";
import {
  downloadDocument,
  fetchCustomerMessages,
} from "../../../../redux/clientPortal/clientPortalslice";

import apiServices from "../../../../service";


const useStyles = makeStyles({
  dialogContent: {
    border: "1px solid #ddd",
    padding: "10px",
    borderRadius: "4px",
  },
  attachmentContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    padding: "10px 0",
    width: "100%",
  },
  chip: {
    border: "1px solid #ddd",
    borderRadius: "4px",
    padding: "4px 8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    fontSize: "14px",
    color: "#616161",
    gap: "5px",
  },
});

function ViewMessage({ open, onClose, messageDetails, customerId }: any) {
  const styles = useStyles();
  const dispatch = useDispatch<AppDispatch>();

  const handleDownload = (doc: any, file: any) => {

    const link = document.createElement("a");
    link.href = file.FileLink;

    link.download = file.DocumentTitle;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    if (!file.IsDownloaded && doc.SentByIFA === false) {
      dispatch(
        downloadDocument({
          messageId: doc.MessageId,
          documentId: file.DocumentId,
        })
      );

      if (customerId) {
        dispatch(fetchCustomerMessages({ customerId }));
      }

    }
  };

  return (
    <Dialog open={open} modalType="modal">
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <DialogTrigger action="close">
                <Button
                  appearance="subtle"
                  aria-label="close"
                  icon={<Dismiss24Regular onClick={onClose} />}
                />
              </DialogTrigger>
            }
          >
            <span className="lineClamp_view">{messageDetails.Subject}</span>
          </DialogTitle>
          <DialogContent className={styles.dialogContent}>
            <Body1 className="lineClamp_view">{messageDetails.Message}</Body1>
            <div className={styles.attachmentContainer}>
              {messageDetails.attachments?.map((file: any, index: number) => (
                <div
                  key={index}
                  className={styles.chip}
                // Trigger download on click
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <Document20Regular
                      style={{
                        color:
                          messageDetails.SentByIFA && messageDetails.IsDownloaded
                            ? "#205393"
                            : "#616161 !important",
                      }}
                    />
                    <Tooltip
                      withArrow
                      appearance="inverted"
                      positioning={"below"}
                      content={file.DocumentTitle}
                      relationship="label"
                    >
                      <p
                        style={{ color: "#000", maxWidth: "150px" }}
                        className="lineClamp"
                      >
                        {file.DocumentTitle}
                      </p>
                    </Tooltip>
                  </div>
                  {messageDetails.IsDownloaded ? (
                    <Tooltip
                      withArrow
                      appearance="inverted"
                      positioning={"below"}
                      content={
                        messageDetails.SentByIFA && messageDetails.IsDownloaded
                          ? `Downloaded at: ${moment(
                            messageDetails.DownloadAt
                          ).format("DD/MM/YYYY HH:mm a")}`
                          : ""
                      }
                      relationship="label"
                    >
                      <ArrowDownload20Filled
                        style={{ color: "#205393" }}
                        onClick={() => handleDownload(messageDetails, file)}
                      />
                    </Tooltip>
                  ) : (
                    <ArrowDownload20Filled
                      onClick={() => handleDownload(messageDetails, file)}
                    />
                  )}
                </div>
              ))}
            </div>
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export default ViewMessage;
